/**
 * 작성자 : 박승호
 * 날짜 : 2025.03.28
 * 기능 : 방송장비-방송음원정보-방송 장비 음원 정보 모달
 */

import { useState, Dispatch, SetStateAction } from 'react';
import { toast } from 'react-toastify';
import { useRecoilValue } from 'recoil';
import { userState } from '../../atoms';
import { IAuth, IModal } from 'customTypes';
import { ModalBackground, Modal } from '../../assets/styles/Modal';
import { BtnBlue } from '../Button';
import { useTranslation } from 'react-i18next';
import { apiPatch } from '../../services/_common';
import SelectBox from '../SelectBox';
import { logPost } from '../../services/log';

interface IProps {
  openModal: any;
  setOpenModal: Dispatch<SetStateAction<IModal>>;
  auth: IAuth;
  eventDetectList: any;
  refetch: any;
}

const SpeakerAudioInfoModal = ({ openModal, setOpenModal, auth, eventDetectList, refetch }: IProps) => {
  const { t } = useTranslation();
  const userInfo = useRecoilValue(userState);
  const [detectEvent, setDetectEvent] = useState<any>({ type: 'detectEvent', detectEvent: '0', cdName: t('미선택') });

  // 모달 닫기
  const onClickClose = () => {
    setOpenModal((prev: IModal) => ({ ...prev, status: false }));
  };

  const onClickSave = async () => {
    const req = {
      hCd: userInfo.hCd,
      sCd: userInfo.sCd,
      bsCd: openModal.bsCd,
      ...(detectEvent.detectEvent === 'fireAudio' ? { fireAudioId: openModal.data.customAudioID } : {}),
      ...(detectEvent.detectEvent === 'helmatAudio' ? { helmetAudioId: openModal.data.customAudioID } : {}),
    };

    const res = await apiPatch({ path: '/bs/alarmconfig', contentType: 'application/json', req });

    if (res.data.statusCode === 200) {
      toast.success('저장되었습니다.');
      refetch();
      onClickClose();
      await logPost({
        hCd: userInfo.hCd,
        sCd: userInfo.sCd,
        userId: userInfo.userId,
        menu: '방송 장비 알람 설정',
        action: '저장',
        etc: `방송 장비 알람 설정 수정`,
      });
    } else {
      toast.error('저장에 실패하였습니다.');
    }
  };

  return (
    <ModalBackground onClick={onClickClose} role='presentation'>
      <Modal>
        <div
          className='modal height-fit signup'
          role='presentation'
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          <div className='inputForm-head'>
            <div className='modalHeaderTitle'>{t('방송 장비 음원 정보')}</div>
            <div className='closeBtn' onClick={onClickClose} role='presentation'>
              <span className='material-symbols-rounded'>close</span>
            </div>
          </div>

          <div className='black flexColumn flex-between col-w100' style={{ minHeight: '500px' }}>
            <div className='filter-option-grid grid1'>
              <div className='viewOnly'>
                <label htmlFor='bsfName' className='w7rem'>
                  {t('음원명')}
                </label>
                <div>{openModal.data.bsfName}</div>
              </div>
              <div className='viewOnly'>
                <label htmlFor='audioType' className='w7rem'>
                  {t('형식')}
                </label>
                <div>{openModal.data.audioType}</div>
              </div>
              <div className='viewOnly'>
                <label htmlFor='time' className='w7rem'>
                  {t('파일크기')}
                </label>
                <div>{openModal.data.bsfFsize}</div>
              </div>
              <div className='viewOnly'>
                <label htmlFor='bsfFtime' className='w7rem'>
                  {t('재생시간')}
                </label>
                <div>{openModal.data.bsfFtime}</div>
              </div>
              <div className='selectWrapper'>
                <label htmlFor='actionStatus'>{t('감지 알림음 선택')}</label>
                <SelectBox
                  options={eventDetectList}
                  defaultOption={t(openModal.data?.cdName) || t('미선택')}
                  state={detectEvent}
                  setState={setDetectEvent}
                  stateKey='detectEvent'
                  initiateKey={openModal.data?.detectEvent}
                  filterbar='filter-1-left'
                  optionHeight='height-md'
                  disabled={openModal.data?.detectEvent !== '0'}
                />
              </div>
            </div>
          </div>

          <div className='modal-footer flex-between flex-end'>
            <div className='flex-basic'>{(auth.createAuth || auth.updateAuth) && <BtnBlue onClick={onClickSave}>{t('저장')}</BtnBlue>}</div>
          </div>
        </div>
      </Modal>
    </ModalBackground>
  );
};

export default SpeakerAudioInfoModal;
